import React from "react";
import Line from "../components/Polygon+Line";
import RollingNumber from "../components/RollingNumber";
import { HashLink } from "react-router-hash-link";
import { Player } from "@lottiefiles/react-lottie-player";

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <div className=" px-4 py-8 bg-white lg:w-[1024px] [@media(min-width:1100px)and(max-width:1279)]:w-[1100px] xl:w-full lg:mx-auto flex flex-col items-center justify-center md:m-0 md:py-12">
        <div className="grid md:grid-cols-[2fr_1fr] gap-8 max-w-6xl w-full items-center ">
          {/* Left Section */}
          <div className="space-y-2 text-center md:text-left">
            <section id="home">
              <p className="text-gray-400 uppercase tracking-widest text-sm ">
                Present. Design. Deliver
              </p>
            </section>
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-snug relative inline-block">
              <span className="inline-flex items-center justify-center md:justify-start">
                Smarter Tech
                <div
                    className="
                      inline-block 
                      w-10 h-10                /* default small size for mobile */
                      sm:w-12 sm:h-12          /* small devices */
                      md:w-20 md:h-20 md:ml-2  /* tablets and desktops */
                    "
                    >
                <Player autoplay loop src="Setting.json" className="inline " />
                </div>
              </span>
              <br />
              Sharper Design
              <br />
              <span className="inline-flex pl-4 sm:pl-10 md:p-0 lg:p-0  items-center justify-center md:justify-start">
                Stronger Growth
                    <div
                    className="
                      inline-block 
                      w-10 h-10                /* default small size for mobile */
                      sm:w-12 sm:h-12          /* small devices */
                      md:w-20 md:h-20 md:ml-2  /* tablets and desktops */
                    "
                    >
                    <Player
                      autoplay
                      loop
                      src="Growth Arrow.json"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>

              </span>
            </h1>

            <div className="mt-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-8 justify-center md:justify-start">
              <HashLink
                className="text-white bg-[#B20925] px-6 sm:px-8 py-3 rounded-lg font-roboto shadow-lg w-[160px] text-center"
                to="/ContactUs"
              >
                Book a call
              </HashLink>

              <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
                <img src="Play.svg" alt="Play" className="w-5 h-5" /> Play Video
              </button>
            </div>
          </div>

          {/* Right Section */}
          <div className="relative flex justify-center items-center mt-10 md:mt-0">
            {/* Main Box of Animation */}
            <div
              className=" relative w-[90%] h-[320px] sm:w-[80%] md:w-[500px] md:h-[350px] rounded-bl-lg rounded-br-lg flex justify-center items-center"
              style={{ boxShadow: "8px 4px 12px rgba(0,0,0,0.3)" }}
            >
              {/* The Corner Red Deisgn on the Animation Box */}
              <div className="absolute  top-[-7%] right-[-3%] sm:top-[-7%] sm:right-[-3%] md:top-[-7%] md:left-[79%] lg:top-[-20px] lg:left-[400px] border-t-20 rounded-xl border-[#B20925]  w-30 "></div>
              <div className="absolute  top-[-7%] right-[-3%] sm:top-[-7%] sm:right-[-3%] md:top-[-7%] md:left-[100%] lg:top-[-20px] lg:left-[500px] border-r-20 rounded-xl border-[#B20925]  h-26 "></div>

              {/*Outer Circle */}
              <div className="w-74 h-74 border-2 border-dashed border-gray-300 rounded-full flex justify-center items-center">
                {/*Inner Circle */}
                <div className="relative w-47 h-47 border-2 border-dashed border-gray-300 rounded-full">
                  <Player
                    autoplay
                    loop
                    src="Three Stages.json" // place this file in public folder or import it
                    className="absolute top-[-66px] left-[-62px] w-[310px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="py-12 md:w-[800px] lg:w-[1000px] mx-auto">
        <div className="md:px-10 grid grid-cols-2 md:grid-cols-4 justify-items-center gap-y-8 text-center ">
          {/* Item 1 */}
          <div>
            <div className="flex items-center">
              <RollingNumber
                initialNumber={10}
                finalNumber={50}
                interval={5000}
                fontSize={48}
              />
              <Line className="pl-7 md:ml-12 md:p-0" />
            </div>
            <p className=" text-gray-500 text-lg mt-1 md:p-0 ">Companies</p>
          </div>

          {/* Item 2 */}
          <div>
            <div className=" ml-10 md:m-0 flex items-center">
              <RollingNumber
                initialNumber={20}
                finalNumber={60}
                interval={6000}
                fontSize={48}
              />
              <Line className="pl-7 md:ml-12 md:p-0" />
            </div>
            <p className="pl-3 text-gray-500 text-lg mt-1 md:p-0">
              Happy Clients
            </p>
          </div>

          {/* Item 3 */}
          <div>
            <div className="ml-13 md:m-0 flex items-center">
              <RollingNumber
                initialNumber={1}
                finalNumber={5}
                interval={7000}
                fontSize={48}
              />
              <Line className="pl-7 md:ml-25 md:p-0" />
            </div>
            <p className="text-gray-500 text-lg mt-1">Years Of Experience</p>
          </div>

          {/* Item 4 */}
          <div>
            <div className="ml-10 md:0 flex items-center">
              <RollingNumber
                initialNumber={100}
                finalNumber={500}
                interval={8000}
                fontSize={48}
              />
              <Line className="pl-0 md:ml-12 md:p-0" />
            </div>
            <p className=" text-gray-500 text-lg mt-1 md:p-0">
              Successful Projects
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
